module.exports = require('./$.global').document && document.documentElement;


//////////////////
// WEBPACK FOOTER
// F:/Solutions/7572bo/master/~/vue2-google-maps/~/core-js/library/modules/$.html.js
// module id = 297
// module chunks = 1